import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../../../../EmptyFragment';
import { ProductLicenseResource, ScheduledProgramInstanceOption } from '../../../../../../../Types';
import LearningDesignExperienceStore from '../../../../../../Experience/Store';
import { selectable, selectableOption, selectedInExperienceStore } from '../../../../DateSelection';
import DateCheckbox from './DateCheckbox';

export interface Props {
  scheduledOption: ScheduledProgramInstanceOption;
  experienceStore: LearningDesignExperienceStore;
  productLicense: ProductLicenseResource;
}

function SelectableDate({ scheduledOption, experienceStore, productLicense }: Props) {
  return selectableOption(scheduledOption, productLicense)
    .orElse(() => selectedInExperienceStore(experienceStore, scheduledOption))
    .map((option) => (
      <DateCheckbox
        scheduledOption={option}
        experienceStore={experienceStore}
        selectable={selectable(option, productLicense)}
      />
    ))
    .getOrElse(emptyFragment);
}

export default observer(SelectableDate);
